import React, { useState } from "react";
import "./Gal.css";
import { FaLanguage } from "react-icons/fa";

const OurGallery = () => {
  const [isTamil, setIsTamil] = useState(false);

  const galleryItems = [
    
    { image: "news4.jpg" },
  ];

  return (
    <section id="custom-gallery" className="custom-gallery-section">
      <div className="custom-gallery-header">
        <h2 className="custom-gallery-title">
          {isTamil ? "எங்கள் கேலரி" : "Our Gallery"}
        </h2>
        <button
          onClick={() => setIsTamil(!isTamil)}
          className="custom-gallery-translate-btn"
        >
          <FaLanguage />
          {isTamil ? "Translate to English" : "Translate to தமிழ்"}
        </button>
      </div>

      <div className="custom-gallery-grid">
        {galleryItems.map((item, index) => (
          <div key={index} className="custom-gallery-card">
            <img
              src={item.image}
              alt={`gallery-${index}`}
              className="custom-gallery-image"
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default OurGallery;
